var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container card" }, [
    _c("div", { staticClass: "card__preview-wrp" }, [
      _vm.sale.details.youtube_video_id
        ? _c("div", [
            _c("iframe", {
              staticClass: "card__video",
              attrs: {
                src:
                  "https://www.youtube.com/embed/" +
                  _vm.sale.details.youtube_video_id +
                  "?rel=0&start=0&end=60"
              }
            })
          ])
        : _c("img", {
            attrs: { src: _vm.imgUrl || _vm.getUrl, alt: "campaign_preview" }
          })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card__content" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("div", { staticClass: "card-header__status" }, [
          _vm.sale.state === "canceled"
            ? _c(
                "span",
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/cancel_icon.svg" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sale.state === "closed"
            ? _c(
                "span",
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/cancel_icon.svg" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sale.state === "open"
            ? _c(
                "span",
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/pending_icon.svg" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("span", [
            _vm.sale.state === "open"
              ? _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.sale.daysToEnd === 0
                        ? _vm.i18n.sale_ends_today()
                        : _vm.i18n.sale_to_end({ days: _vm.sale.daysToEnd })
                    ) + " "
                  )
                ])
              : _c("span", [
                  _vm._v(
                    _vm._s(_vm.i18n.com_campaign()) +
                      " " +
                      _vm._s(_vm.saleStatus)
                  )
                ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-header__type" }, [
          _vm._v(_vm._s(_vm.saleType))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-description" }, [
        _c("div", { staticClass: "text_bold text_medium" }, [
          _vm._v(_vm._s(_vm.sale.name))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card__text text_small" }, [
          _vm._v(_vm._s(_vm.sale.shortDescription))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-progress" }, [
        _c("div", { staticClass: "card-progress__stats text_small" }, [
          _vm.profitability
            ? _c(
                "div",
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/grow_up_icon.svg" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text_small" }, [
                    _vm._v(_vm._s(_vm.profitability))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("md-icon", {
                attrs: { "md-src": "/static/img/man_icon.svg" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text_small" }, [
                _vm._v(_vm._s(_vm.sale.investors))
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-progress__bar" }, [
          _c("div", {
            staticClass: "progress-line",
            style: "width: " + _vm.progress + "%"
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-progress__amounts" }, [
          _c("div", { staticClass: "text_medium text_bold text_description" }, [
            _vm._v(
              _vm._s(_vm.assetIcon(_vm.sale.defaultQuoteAsset)) +
                " " +
                _vm._s(
                  _vm.roundCurrency(
                    _vm.sale.currentCap,
                    _vm.sale.defaultQuoteAsset
                  )
                ) +
                " "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text_medium text_bold card__goal-amount" },
            [
              _vm._v(
                _vm._s(_vm.assetIcon(_vm.sale.defaultQuoteAsset)) +
                  " " +
                  _vm._s(
                    _vm.roundCurrency(
                      _vm.sale.hardCap,
                      _vm.sale.defaultQuoteAsset
                    )
                  )
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7478b5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7478b5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_card/Sales.SaleCard.vue
// module id = Tr98
// module chunks = 1